var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.78 16.11c-.34-.338-.163-.242-.978-.46-.37-.1-.696-.29-.99-.519L5.047 19.46c-.171.42.148.875.6.858l2.05-.079 1.41 1.49c.312.328.858.226 1.029-.193l2.025-4.966c-.422.235-.89.373-1.374.373-.759 0-1.471-.295-2.008-.832zm11.115 3.35L18.13 15.13c-.295.229-.62.42-.99.518-.82.22-.64.124-.977.461-.537.537-1.25.832-2.009.832-.484 0-.952-.138-1.374-.373l2.026 4.966c.17.419.717.521 1.028.193l1.41-1.49 2.05.079c.453.017.772-.439.601-.858zm-4.661-4.23c.594-.605.662-.553 1.509-.784.54-.147.963-.577 1.108-1.127.29-1.105.215-.972 1.01-1.78.395-.403.55-.99.405-1.54-.29-1.105-.291-.95 0-2.056.145-.55-.01-1.138-.406-1.54-.794-.809-.718-.676-1.01-1.78-.144-.55-.567-.98-1.107-1.128-1.085-.296-.954-.219-1.75-1.028-.395-.402-.972-.56-1.512-.413-1.085.296-.933.297-2.02 0-.54-.147-1.117.01-1.513.413-.794.809-.663.732-1.749 1.028-.54.147-.963.577-1.107 1.127-.291 1.105-.216.972-1.01 1.78-.396.403-.55.99-.406 1.54.291 1.104.291.95 0 2.056-.144.55.01 1.137.406 1.54.794.809.718.676 1.01 1.78.144.55.567.98 1.107 1.128.871.238.936.2 1.51.784.514.524 1.316.618 1.935.226.505-.32 1.15-.32 1.655 0 .618.392 1.42.298 1.935-.226zM8.8 8.847c0-2.063 1.644-3.736 3.67-3.736 2.028 0 3.672 1.673 3.672 3.736s-1.644 3.736-3.671 3.736S8.8 10.91 8.8 8.847z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.010f392beb291ae91757e1840904fcf1.svg";
export { ForwardRef as ReactComponent };